import './style.css'
import ReactDom from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import * as THREE from 'three'
import { StrictMode } from 'react'
import { Leva } from 'leva'
import { KeyboardControls } from '@react-three/drei'

import { SpeedInsights } from "@vercel/speed-insights/react"
import { Analytics } from "@vercel/analytics/react"

import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'
import { ApolloProvider } from '@apollo/client/react'

import AdBlockBanner from './components/main/AdBlockBanner'
import { DEBUG_MODE } from './config/debug'

import Experience from './components/main/Experience'
import CameraController from './components/main/CameraController'
import Effects from './components/main/Effects'
import Hud from './components/main/Hud'
import OrologioSchermo from './components/main/OrologioSchermo'
import Tutorial from './components/main/Tutorial'
import Guida from './components/main/Guida'
import LoadingScreen from './components/main/LoadingScreen'
import TouchJoystick from './components/main/TouchJoystick'
import { IS_TOUCH } from './config/touch'
import ProductPage from './components/shopify/ProductPage'
import CartUI from './components/shopify/CartDrawer'
import SearchOverlay from './components/shopify/SearchOverlay'
import CassaOverlay from './components/shopify/CassaOverlay'
import GumballPremio from './components/main/GumballPremio'


const client = new ApolloClient({
  link: new HttpLink({
    uri: 'https://3utay1-jd.myshopify.com/api/2025-01/graphql.json',
    headers: {
      'X-Shopify-Storefront-Access-Token': '9c209c653cf57275908a341967945437'
    }
  }),
  cache: new InMemoryCache()
})

// IL SITO E' UNA PAGINA SOLA, e Vercel risponde con l'app a QUALUNQUE
// percorso. Chi arriva da un link con un percorso dentro — per esempio
// momoz.shop/password, che la vetrina Shopify produce rimbalzando qui —
// vede il negozio giusto ma un indirizzo che non vuol dire niente. Lo si
// ripulisce subito, tenendo la query (?debug, ?prodotto) e l'ancora.
if (window.location.pathname !== '/') {
  window.history.replaceState({}, '', '/' + window.location.search + window.location.hash)
}

const root = ReactDom.createRoot(document.querySelector('#root'))

root.render(
  <ApolloProvider client={client}>
    <SpeedInsights/>
    <Analytics />
    <AdBlockBanner />
    <StrictMode>
      {/* Pannello Leva solo in modalità debug (?debug nell'URL) */}
      <Leva collapsed hidden={!DEBUG_MODE} />
      {/* UI 2D e-commerce sopra il mondo 3D */}
      <LoadingScreen />
      <Hud />
      {/* quadrante dell'orologio: ospita i pulsanti (portal) */}
      <OrologioSchermo />
      <Tutorial />
      {/* la mascotte nell'angolo, che dà una mano */}
      <Guida />
      <SearchOverlay />
      <TouchJoystick />
      <ProductPage />
      <CartUI />
      <CassaOverlay />
      {/* sempre montato: chiede al server se la macchinetta e' accesa */}
      <GumballPremio />
      <KeyboardControls
        map={[
          { name: 'forward', keys: ['ArrowUp', 'KeyW' ] },
          { name: 'backward', keys: ['ArrowDown', 'KeyS'] },
          { name: 'left', keys: ['ArrowLeft', 'KeyA'] },
          { name: 'right', keys: ['ArrowRight', 'KeyD'] },
          { name: 'shift', keys: ['ShiftLeft', 'ShiftRight'] },
          // Ctrl = abbassarsi. La C era gia' del carrello, e Ctrl e' il
          // tasto che chi gioca si aspetta per accovacciarsi.
          { name: 'giu', keys: ['ControlLeft', 'ControlRight'] }
        ]}
      >
        <Canvas
          dpr={ IS_TOUCH ? [ 1, 1.5 ] : [ 1, 2 ] }
          gl={ {
            antialias: false,
            toneMapping: THREE.ACESFilmicToneMapping,
            outputColorSpace: THREE.SRGBColorSpace,
          } }
          camera={ {
            fov: 70,
            near: 0.1,
            far: 200,
            rotation: [0, Math.PI/2, 0],
            position: [0, 5, 0]
          } }
          // onCreated={ created }
        >
          {/* Post-processing pesante per le GPU mobili → solo desktop */}
          {!IS_TOUCH && <Effects />}
          <CameraController />
          <Experience />
          
        </Canvas>
      </KeyboardControls>
    </StrictMode>
  </ApolloProvider>
)
